import { SampledKeysArray, SimulationData, TransformedData } from 'src/app/core/model';
import { ApiResponse } from 'src/app/shared/model/ApiResponse';

export class TemplateConfigurationAdapter {

  public static parseData(response: any): ApiResponse<TransformedData[]> {

    if (!response || !Array.isArray(response)) {
      return new ApiResponse(true, 'Unable to get template configurations data');
    }

    if (response?.length == 0) {
      return new ApiResponse(true, 'No template configurations found');
    }

    let transformedData: TransformedData[] = [];

    response?.forEach((eachTemplateConfiguration: any) => {
      const sampledFields: SampledKeysArray[] = (eachTemplateConfiguration?.sampledFields || [])?.map((key: string) => ({
        key: key,
        sampling: false,
        disabled: false,
      }));
      const simulationData: SimulationData[] = eachTemplateConfiguration?.fieldMappings?.map((field: any) => ({
        name: field?.key,
        sampling: field?.sampling,
        attributes: {
          ...field?.attributes,
          name: field?.name,
          description: field?.description,
          type: field?.order,
        },
      }));
      transformedData.push({
        sampledFields: sampledFields,
        simulationData: simulationData,
      });
    });
    return new ApiResponse<TransformedData[]>(false, '', transformedData);
  }
}